import React from 'react';

import { Chip } from '@mui/material';

import { Stack, Typography, styled } from '@liscio/ui';

export const FieldLabel = styled('span')(({ theme }) => ({
  textTransform: 'uppercase',
  fontWeight: 600,
  fontSize: '0.75rem',
  color: theme.palette.common.blueGray?.[500] ?? theme.palette.text.secondary,
  letterSpacing: '0.02em',
}));

export const RequiredMark = styled('span')({
  color: '#d32f2f',
  marginLeft: 2,
});

export const SubsectionTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '0.875rem',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.5),
}));

export const LabeledField: React.FC<{
  label: React.ReactNode;
  required?: boolean;
  children: React.ReactNode;
}> = ({ label, required, children }) => (
  <Stack spacing={0.5} width="100%">
    <FieldLabel>
      {label}
      {required && <RequiredMark>*</RequiredMark>}
    </FieldLabel>
    {children}
  </Stack>
);

export const OptionalFieldsBadge: React.FC = () => (
  <Chip
    label="Optional"
    size="small"
    sx={{
      height: 22,
      fontSize: '0.75rem',
      fontWeight: 500,
      bgcolor: (theme) =>
        theme.palette.common.blueGray?.[100] ?? theme.palette.grey[100],
      color: (theme) =>
        theme.palette.common.blueGray?.[600] ?? theme.palette.text.secondary,
      border: 'none',
    }}
  />
);
